<template>
  <section class="address-list">
    <ServerDeleteConfirm
      v-if="serverDeleteConfirm.active"
      :selected-count="rowsSelected.length"
      :loading="serverDeleteLoading"
      @approve="removeSelectedRows"
      @close="serverDeleteConfirm.active = false"
    />
    <div class="address-list__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="address-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="serversMeta.current_page"
        v-bind="{
          totalItems: serversMeta.total,
          itemsByPage: serversMeta.per_page,
        }"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="address-list__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MockIntercomServerList from '../../mixins/Mock/MockIntercomServerList.js'
import Pagination from '../../components/Pagination.vue'
import ServerDeleteConfirm from '../Popup/ServerDeleteConfirm.vue'

export default {
  name: 'AddressList',
  mixins: [MockIntercomServerList],
  components: { Filters, Table, Actions, Pagination, ServerDeleteConfirm },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    }
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterServers(value)
      },
      deep: true,
    },
  },
  computed: {
    serversMeta() {
      return this.$store.getters.serversMeta
    },
  },
}
</script>

<style lang="scss" scoped>
.address-list {
  &__filters {
    margin: 0px $space-md $space-lg;
  }

  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
